import React from "react";
import "../Navigation/css/NavBar.scss";

export default function ChangeHistory() {
    return (
        <div>
            Change History
        </div>
    )
}